import * as React from "react";
import { forwardRef } from "react";
const SvgIcDivider = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3 9V12M21 9V12M21 15V12M3 15V12M3 12H21", stroke: "#241D47", strokeWidth: 1.5, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgIcDivider);
export default ForwardRef;
